import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';
import { JwtService } from './jwt.service';
import { Router } from '@angular/router';
import { LayoutService } from './layout.service';
import { PopupService } from './popup.service';

interface TokenResponse {
  token: string;
  refreshToken: string;
  expiresIn: Date;
}

interface TokenRequest {
  Email: string;
  Password: string;
}

interface RefreshTokenRequest {
  refreshToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: any;
  private readonly baseUrl = environment.coreapipath;
  private tokenSubject: BehaviorSubject<TokenResponse | null> = new BehaviorSubject<TokenResponse | null>(null);
  Credentials!: {
    userType: any;
    firstName: any;
    refreshToken: any;
    userImageURL: any;
    refreshTokenExpiryTime: any;
    enterpriseId: number;
    lastName: any;
    emailId: any;
    Phone: any;
    profileImage: any;
    profileImagePath: any;
    profile_status: any;
    userId: any;
    CreatedDate: any;
    UpdatePwdDate: any;
    PasswordUpdateOn: any;
    Role: string;
    CreatedBy: any;
  };
  UserData: any;
  constructor(
    private apiService: ApiService,
    private storageService: StorageService,
    private jwtService: JwtService,
    private router: Router,
    private layoutService: LayoutService,
    private popupService: PopupService
  ) {

  }

  Login(email: string, password: string): Observable<TokenResponse> {
    const tokenRequest: TokenRequest = { Email: email, Password: password };

    return this.getTokenLogin(tokenRequest).pipe(
      switchMap(response => of(response)),
      catchError(error => {
        console.error('Login failed:', error);
        return throwError('Login failed');
      })
    );
  }
  getTokenLogin(data: any): Observable<any> {
    return this.apiService.post<any>(`/ISDPToken`, data).pipe(
      tap((tokenResponse: TokenResponse) => {
        this.storageService.saveUser(tokenResponse);
        this.tokenSubject.next(tokenResponse);
      })
    );
  }

  jwtTokenExpCheck() {
    const now = Date.now().valueOf() / 1000;
    const token = this.storageService.getUserToken();
    if (token != null && token != undefined && token != '') {
      const decoded = this.jwtService.getDecodedAccessToken();
      const diffValue = (decoded.exp - now);
      const diffmint = diffValue / 60;
      if (diffmint <= 5 && diffmint >= 2) {
        //this.refreshAccessToken(token);
      }
      if (diffmint <= 1) {
        this.storageService.clean();
        this.router.navigate(['/home']).then(() => {
          window.location.reload();
        });
      }
    }
  }


  private TokenTimeInSeconds!: number;
  public saveTokenExpiryTime(isReferesh: boolean): void {
    this.TokenTimeInSeconds = this.jwtService.getTokenExpiryTime(isReferesh);
    const tokenExpirationInSeconds = this.TokenTimeInSeconds || 0;
    const expirationTime = new Date().getTime() + (tokenExpirationInSeconds * 1000); // Add token expiration time to current time
    localStorage.setItem('tokenExpirationTime', expirationTime.toString());
    console.log('tokenExpirationTime', expirationTime.toString());
  }

  isTokenExpired(): boolean {
    const token = this.storageService.getUserToken();
    if (!token) return true;

    const expirationTime = this.getTokenExpirationTime();
    const currentTime = new Date().getTime();
    return expirationTime <= currentTime;
}

  saveToken(UserData : any){
    this.UserData = UserData;
    this.storageService.saveUser(this.UserData);
    this.saveUserData();
    this.saveTokenExpiryTime(true);
  }

  getToken(): string{
   return this.storageService.getUserToken();
  }

  public getTokenExpirationTime(): number {
    const storedExpirationTime = localStorage.getItem('tokenExpirationTime');
    return storedExpirationTime ? parseInt(storedExpirationTime, 10) : 0;
  }

  getTokenValue(): string | null {
    const token = this.tokenSubject.value;
    return token ? token.token : null;
  }

  refreshAccessToken(): Observable<any> {
    const reftoken = this.storageService.getUserRefereshToken();
    const reftokenexpirytime = this.storageService.getRefTokenExpTime().getTime();
    const currentTime = new Date().getTime();

    if (reftokenexpirytime <= currentTime) {
      this.logout();
      return throwError('Refresh token expired');
    }

    const token = this.storageService.getUserToken();
    if (token) {
      return this.refreshToken(token, reftoken).pipe(
        tap((res) => {
          if (res.succeeded) {
            const userData = res.data;
            this.UserData = res.data;
            if (userData) {
              this.storageService.saveUser(userData);
              this.saveUserData();
              this.saveTokenExpiryTime(true);
            }
          } else {
            this.logout();
          }
        }),
        catchError((error) => {
          this.logout();
          return throwError(error);
        })
      );
    } else {
      this.logout();
      return throwError('No token available');
    }
  }


refreshToken(jwttoken: any, reftoken: any): Observable<any> {
  jwttoken = this.storageService.getUserToken();
  return this.apiService.post(`/ISDPToken/refresh`, { token: jwttoken, refreshToken: "" });
}

logout(isMain:boolean | null = null) {
    this.storageService.clean();
    this.storageService.removeLocalStorage();

    localStorage.clear();
    this.layoutService.setShowSidebar(false);
    this.popupService.closeAllPopups();
    if(isMain){
      this.router.navigate(['/home'])
      .then(() => {
          window.location.reload();
      });
    }else{
      this.router.navigate(['/error'], { queryParams: { status: 498 } })
      .then(() => {
          window.location.reload();
      });
    }
    
}


goToHome(){
    this.storageService.clean();
    this.storageService.removeLocalStorage();
    localStorage.clear();
    this.layoutService.setShowSidebar(false);
    this.popupService.closeAllPopups();
    this.router.navigate(['/home'])
        .then(() => {
            window.location.reload();
        });
}

isTokenExpiringSoon(): boolean {
  const expirationTime = this.getTokenExpirationTime();
  const currentTime = new Date().getTime();
  const timeToRefresh = environment.tokenRefreshThreshold;

  return (expirationTime - currentTime) <= timeToRefresh;
}

  getWithPagination(path: string, searchParams?: object, page?: number, pageSize?: number): Observable<any> {
    // Modify the HttpParams to include pagination parameters
    const modifiedSearchParams = {
      ...searchParams,
      page,
      pageSize
    };
    return this.apiService.get(path, modifiedSearchParams);
  }

  private saveUserData() {
    const decoded = this.jwtService.getDecodedAccessToken();
    this.Credentials = {
      userType: decoded.UserType,
      firstName: decoded.Name,
      refreshToken: decoded.RefreshToken,
      userImageURL: decoded.UserImageURL,
      refreshTokenExpiryTime: decoded.RefreshTokenExpiryTime,
      enterpriseId: Number(decoded.EnterpriseId),
      lastName: decoded.Surname,
      emailId: decoded.Email,
      Phone: decoded.MobilePhone,
      profileImage: decoded.ProfileImage,
      profileImagePath: decoded.ProfileImagePath,
      profile_status: decoded.ProfileStatus,
      userId: decoded.UserId,
      CreatedDate: decoded.CreatedOn,
      UpdatePwdDate: decoded.CreatedOn,
      PasswordUpdateOn: decoded.PasswordUpdateOn,
      Role: "",
      CreatedBy: decoded.CreatedBy,
    };

    const tempvalue = {
      token: this.UserData.token,
      credentials: this.Credentials,
    };

    this.UserData = {
      success: this.UserData.success,
      message: this.UserData.message,
      data: tempvalue,
    };
  }
}
